import { InternalLink, P } from "@sorcery/ui";

import type { UserPageType } from "~/types/user";
import { userPath } from "~/utils/paths";

export const UserFollowers = ({
  user,
  slim,
}: {
  user: UserPageType;
  slim?: boolean;
}) => {
  return (
    <div className={`!mb-8 overflow-auto ${slim && "max-h-24"} max-w-lg`}>
      {!slim &&
        (user.followers.length === 0 ? (
          <>
            <P className="!mb-1">None yet...</P>
            <P>
              To grow your legend, try writing primers on your best decks, follow other users, and
              join the discussion in our discord server.
            </P>
          </>
        ) : (
          <P className="!mb-1">
            You're powerful enough to inspire the masses... These Sorcerers follow your every move.
            Keep them on their toes.
          </P>
        ))}
      {user.followers.map((u, i) => (
        <span key={u.id}>
          <span className="hover:underline">
            <InternalLink href={userPath(u.id)} className="text-red">
              @{u.username}
            </InternalLink>
          </span>
          {i !== user.followers.length - 1 && ","}
        </span>
      ))}
    </div>
  );
};
